import { addDays } from 'date-fns'
import { formatDateForFilter } from '../functions/query-params-helper'

/**
 * Helper function which returns the filter expression used for project tasks
 * @param {string} projectId
 * @param {boolean} filterOldTasks
 * @returns {string}
 */
export function getProjectTasksFilter(projectId: string, filterOldTasks?: boolean): string {
  let filterBy = `projectId eq guid'${projectId}'`

  if (filterOldTasks) {
    const date = formatDateForFilter(addDays(new Date(), -30))
    const statusFilterBy = `taskStatus/type ne 'done' or closedOn ge datetime'${date}'`

    filterBy = `${filterBy} and (${statusFilterBy})`
  }

  return filterBy
}
